import React, { useEffect, useState } from "react";
import { IonCol, IonGrid, IonRow, IonList,IonItem } from "@ionic/react";
import { BiDownArrowCircle, BiUpArrowCircle } from "react-icons/bi";
import {
  FANCY_RESULT_PROFIT_LOSS,
  GET_ACCOUNT_MATCHES_DATA,
  GET_FANCY_ENTRY_DATA,
  GET_MATCH_ENTRY_DETAILS,
  GET_MATCH_POSITION_DATA,
  GET_OFFLINE_USER_DETAILS,
} from "../../src/config/endpoints";
import { axiosInstance,call } from "../../src/config/axios";


function MatchPositionTables(props) {
  const { liveMeeting } = props;
  const [matchPositionTable, setMatchPositionTable] = useState(false);
  const [fancyPLTable, setFancyPLTable] = useState(false);
  const [data, setData] = useState([]);
  const [teamOnePLData, setTeamOnePLData] = useState([]);
  const [teamTwoPLData, setTeamTwoPLData] = useState([]);
  const [fancyPL, setFancyPL] = useState(0);
  const [userMatchEntrys, setUserMatchEntrys] = useState([]);
  const [userFancyPL, setUserFancyPL] = useState([]);
  const [userMatchPL, setUserMatchPL] = useState([]);
  const [userFancyEntrys, setUserFancyEntrys] = useState([]);
  const [profitLossData, setProfitLossData] = useState([]);
  const [matchRegisterData, setMatchRegisterData] = useState([]);
  const [clientId, setClientId] = useState(null);
  const userName = localStorage.getItem("user_name");
  const handleMatchPositionTableOpen = () => {
    setMatchPositionTable(!matchPositionTable);
  };
  const handleFancyPLTableOpen = () => {
    setFancyPLTable(!fancyPLTable);
  };



  const getMatchInfo = async () => {
    console.log("getMatchInfo:", liveMeeting);
    await call(GET_ACCOUNT_MATCHES_DATA, {
      register_id: localStorage.getItem("creator_id"),
      match_id: liveMeeting?.match_id,
    })
      .then(async (res) => {
        let temp =
          res?.data && res.data.data && res.data.data[0]
            ? res.data.data[0]
            : res.data.data;
        setMatchRegisterData(temp);
        // await getMatchPositionData(temp?.registered_match_id);
      })
      .catch((err) => console.log(err));
  };

  const getUserDetails = async () => {
    await call(GET_OFFLINE_USER_DETAILS, {
      existing_user_id: localStorage.getItem("register_id"),
      register_id: localStorage.getItem("creator_id"),
    })
      .then((res) => {
        setClientId(res?.data?.data?.client_id);
      })
      .catch((err) => console.log(err));
  };



  useEffect(() => {
    getMatchInfo();
  }, []);

    useEffect(() => {
    console.log(matchRegisterData,'matchRegisterData')
  if (matchRegisterData?.match_id) {
    fetchMatchPLData(
      matchRegisterData.match_id,
      matchRegisterData.team1,
      matchRegisterData.team2,
      setTeamOnePLData,
      setTeamTwoPLData
    );
  }
}, [matchRegisterData,clientId]);

  const fetchMatchPLData = async (matchId,  team1, team2, setTeamOnePLData, setTeamTwoPLData) => {
  try {
    const response = await axiosInstance.get(
      `/Report/GetMatchInfoByClientId/${matchId}/${clientId}`
    );

    console.log("Response Data:", response.data);
    const matchData = response.data;

    let teamOneTotal = 0;
    let teamTwoTotal = 0;

    if (matchData && Array.isArray(matchData)) {
      matchData.forEach((item) => {
        teamOneTotal += +item?.teamObj?.[team1] || 0;
        teamTwoTotal += +item?.teamObj?.[team2] || 0;
      });
    }

    setTeamOnePLData(matchData.team1Position);
    setTeamTwoPLData(matchData.team2Position);
    setFancyPL(matchData.totalFancyAmount);
    const mappedMatchEntries = matchData.matchEntries?.map(entry => ({
        client_name: entry.clientName,
        team: entry.team,
        pe: entry.pe, 
        amount: entry.riskObject?.winCalculation?.amount || 0
      })) || [];

      // Map fancy entries
      const mappedFancyEntries = matchData.fancyEntries?.map(entry => ({
        client_name: entry.clientName,
        over: entry.over || "N/A", // Placeholder; update if backend provides
        team: matchData.team1, // Assuming team1 for fancy; adjust as needed
        runs: entry.runs || "N/A", // Placeholder; update if backend provides
        yN: entry.yn,
        amount: entry.riskObject?.winCalculation?.amount || 0
      })) || [];

      // Update state with mapped entries
      setUserMatchEntrys(mappedMatchEntries);
      setUserFancyEntrys(mappedFancyEntries)
  } catch (err) {
    console.error("Axios Error Details:", {
      message: err.message,
      response: err.response?.data,
      stack: err.stack,
    });

  }
};



useEffect(() => {
  let intervalId;

  const shouldFetch = matchRegisterData?.match_id && matchRegisterData?.team1 && matchRegisterData?.team2;

  if (shouldFetch) {
    // Call once immediately
    fetchMatchPLData(
      matchRegisterData.match_id,
      matchRegisterData.team1,
      matchRegisterData.team2,
      setTeamOnePLData,
      setTeamTwoPLData
    );

    // Then set interval to repeat every 60 seconds
    intervalId = setInterval(() => {
      fetchMatchPLData(
        matchRegisterData.match_id,
        matchRegisterData.team1,
        matchRegisterData.team2,
        setTeamOnePLData,
        setTeamTwoPLData
      );
    }, 5000);
  }

  return () => {
    if (intervalId) clearInterval(intervalId);
  };
}, [matchRegisterData,clientId]);



  useEffect(() => {
    if (matchRegisterData?.registered_match_id) {
      getUserDetails();
    }
  }, [matchRegisterData?.registered_match_id]);
  return (
    <IonGrid>
      <div className="custom-box-shadow table-page-conatainer">
        <IonRow className="w-100">
          <IonCol size="4">
            <div className="custom-box-shadow p-5 br-15 font-12">
              {liveMeeting?.date}
            </div>
          </IonCol>
          <IonCol size="4">
            <div className="custom-box-shadow p-5 br-15 font-12">T20</div>
          </IonCol>
          <IonCol size="4">
            <div className="custom-box-shadow p-5 br-15 font-12">
              {liveMeeting?.match_name}
            </div>
          </IonCol>
        </IonRow>
        <IonRow
          class="w-100 p-5 custom-box-shadow br-10 mt-10 flex-space-between font-14 fw-600"
        >
           <IonCol size="6">
            <div>{matchRegisterData?.team1}</div>
            <div className={`${teamOnePLData > 0 ? "green-clr" : "red-clr"}`}>
              {teamOnePLData}
            </div>
           </IonCol>
           <IonCol size="6">
            <div>{matchRegisterData?.team2}</div>
            <div className={`${teamTwoPLData > 0 ? "green-clr" : "red-clr"}`}>
              {teamTwoPLData}
            </div>
           </IonCol>
        </IonRow>
            <div className="w-100 fw-600 d-flex p-1 ml-tbl" >
          <div className="col flex-center">S.NO</div>
          <div className="col flex-center">TEAM</div>
          <div className="col flex-center">P/E</div>
          <div className="col flex-center">AMOUNT</div>
        </div>
        <hr className="sb-line" />
        <div className="w-100">
          {userMatchEntrys?.length > 0 &&
            userMatchEntrys
              ?.map((item, index) => (
                <>
                  <div className="w-100 d-flex p-1 ml-tbl" key={index}>
                    <div className="col flex-center">{index + 1}</div>
                    <div className="col flex-center">{item?.team}</div>
                    <div className="col flex-center">{item?.pe}</div>
                    <div className="col flex-center">{item?.amount}</div>
                  </div>
                  <hr className="sb-line" />
                </>
              ))}
        </div>
        
        <div
          className="custom-box-shadow user-match-position flex-space-between font-16 p-5"
        >
          <p>
            Fancy P/L=
            <span className="custom-box-shadow br-5 win-amount">
              {fancyPL || 0}
            </span>
          </p>

        </div>
              <hr className="sb-line" />
        <div className="w-100 fw-600 d-flex p-1 ml-tbl">
          <div className="col flex-center">OVER</div>
          <div className="col flex-center">TEAM</div>
          <div className="col flex-center">RUNS</div>
          <div className="col flex-center">Y/N</div>
          <div className="col flex-center">AMOUNT</div>
        </div>
        <hr className="sb-line" />
        <div className="w-100">
          {userFancyEntrys?.length > 0 &&
            userFancyEntrys
              ?.map((item, index) => (
                <>
                  <div className="w-100 d-flex p-1 ml-tbl" key={index}>
                    <div className="col flex-center">{item?.over}</div>
                    <div className="col flex-center">{item?.team}</div>
                    <div className="col flex-center">{item?.runs}</div>
                    <div className="col flex-center">{item?.yN}</div>
                    <div className="col flex-center">{item?.amount}</div>
                  </div>
                  <hr className="sb-line" />
                </>
              ))}
        </div>
      </div>
    </IonGrid>
  );
}

export default MatchPositionTables;
